







import { defineComponent } from '@nuxtjs/composition-api';
import { UCIcon } from '@shared/ui';

export default defineComponent({
  name: 'UCPill',
  components: {
    UCIcon,
  },
  props: {
    text: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: null,
    },
  },
});
